import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import { format } from "date-fns";
import PropTypes from "prop-types";

export default function Stat_pumppari_PersonKeikkaCountChart({ data }) {
  // Aggregate keikkaCount per month and year
  const monthlyData = data.reduce((acc, curr) => {
    const yearMonth = `${curr.year}-${curr.month}`;
    const existing = acc.find((item) => item.yearMonth === yearMonth);
    if (existing) {
      existing.keikkaCount += curr.keikkaCount;
    } else {
      acc.push({ yearMonth, keikkaCount: curr.keikkaCount });
    }
    return acc;
  }, []);

  // Sort data by year and month
  monthlyData.sort((a, b) => new Date(a.yearMonth) - new Date(b.yearMonth));

  // Custom tooltip renderer
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip">
          <p className="label">{`${format(new Date(label), "yyyy-MM")}`}</p>
          <p className="intro">{`${payload[0].value} kpl`}</p>
        </div>
      );
    }

    return null;
  };
  CustomTooltip.propTypes = {
    active: PropTypes.bool,
    payload: PropTypes.array,
    label: PropTypes.string,
  };

  return (
    <div>
      <h4 className="center">Tilausten lukumäärä</h4>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={monthlyData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="yearMonth"
            tickFormatter={(yearMonth) => format(new Date(yearMonth), "yyyy-MM")}
          />
          <YAxis label={{ value: "kpl", angle: -90, position: "insideLeft" }} />
          <Tooltip content={<CustomTooltip />} />
          <Bar dataKey="keikkaCount" fill="#82ca9d" name="Keikka Count" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

Stat_pumppari_PersonKeikkaCountChart.propTypes = {
  data: PropTypes.array,
};
